module.exports = __webpack_public_path__ + "e1913195d78d3eb218df7127526c4514.svg";